import { getAccountRoutes } from '~/router/routes/shared/account/common'

export default getAccountRoutes('/account')
